import { SchoolApiDto } from '@lx/shared/api/models';

export type SchoolTypes = SchoolApiDto.TypesEnum;
export const SchoolTypesEnum = SchoolApiDto.TypesEnum;
